import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';

const Address = ({
  data,
  handleAddressSelect,
  editPopup,
  setEditPopup,
  onDelete,
  type,
}) => {
  const displayNameLabel = (data, type) => {
    if (Number(type) === 2) {
      return (
        <span className="fw-600 fs-md text-accent-forground">
          {data.clinic_name !== '' ? (
            <>{data.clinic_name}</>
          ) : (
            <>{data.nameLabel}</>
          )}
        </span>
      );
    }
    if (Number(type) === 3 || Number(type) === 5) {
      return (
        <span className="fw-600 fs-md text-accent-forground">
          {data.nameLabel}
        </span>
      );
    }
    if (Number(type) === 4) {
      return (
        <span className="fw-600 fs-md text-accent-forground">
          {data.nameLabel}
        </span>
      );
    }
  };

  return (
    <div className="mt-3 addressCard border border-lightgray p-4 rounded-lg bg-white">
      <div className="flex justify-between items-start gap-3 mb-2">
        <div
          className="flex items-center gap-2 flex-1 min-w-0 cursor"
          onClick={() => handleAddressSelect(data)}
        >
          {displayNameLabel(data, type)}
          {data?.speciality && (
            <span className="fs-13 badge-gray-100 text-accent-forground rounded-full p-1-5 px-3 flex-shrink-0">
              {data?.speciality}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <div
            className="text-gray-400 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setEditPopup({ open: true, referringMasterId: data.id });
            }}
          >
            <EditIcon style={{ fontSize: '1rem' }} />
          </div>
          <div
            className="text-gray-400 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(data.id);
            }}
          >
            <DeleteOutlineOutlinedIcon style={{ fontSize: '1.2rem' }} />
          </div>
        </div>
      </div>

      <div
        className="bodyLeftRowData cursor"
        onClick={() => handleAddressSelect(data)}
      >
        {data.clinic_name !== '' &&
          data.nameLabel !== '' &&
          Number(type) === 2 && (
            <span className="flex fw-600 fs-md text-accent-forground mb-2">
              {data.nameLabel}
            </span>
          )}
        <span className="flex w-100 fs-sm text-accent-forground">
          {data.addressLabel}
        </span>
        <span className="flex items-center gap-2 w-100 fs-13 text-accent-forground mt-2">
          <EmailOutlinedIcon style={{ fontSize: '1.1rem' }} />
          {data.email}
        </span>
        <span className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2 fs-13 text-accent-forground">
          {data?.phone_l && (
            <span className="flex items-center gap-1">
              <PhoneOutlinedIcon style={{ fontSize: '1.1rem' }} />
              <span>Desk: {data.phone_l}</span>
            </span>
          )}
          {data?.phone_m && (
            <span className="flex items-center gap-1">
              <PhoneAndroidIcon style={{ fontSize: '1.1rem' }} />
              <span>Cell: {data.phone_m}</span>
            </span>
          )}
          {data?.fax && <span>Fax: {data.fax}</span>}
          {data?.npi_no && <span>NPI: {data.npi_no}</span>}
        </span>
        <div className="pt-2 mt-2 border-t border-t-lightgray">
          <p className="fs-13 text-accent-forground mb-0">
            <strong>Notes:</strong> {data?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Address;
